webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAACXBIWXMAAAsSAAALEgHS3X78AAABDUlEQVQ4ja2UsXHDIBSGP6kIrbrQmWzgEXTRAskGGcEreANt4BGiBbhLNpAmiNxR2iUVKYJygGVizvkbwfsf373Tg1c558hJyO4F2AKjNXrI5VY5mAe9B6HXHLDOlgX9H/vbYEJ2b8AmCW98/HaYkN0OOFw5c/D+hSrn3PJvdoBaqSanIzADvTV6qB4enxXwVQC4pqfaV/MfUrU1+gOY7gRNwLg0oL0DOAGtNfr0e2mF7BpgpLwBW2v0CYKr4QPZ57KiYQFFsMUshYWbFNYWwqL8FKYKYVF+CmtWDhyBT/9NFeWnsB44+/UZ2FujlTW6tUYrYJ/40RS5mGdCdsqXP4adCvyGn2E5W6Pn0PsGXJtekmJnbOsAAAAASUVORK5CYII="

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        changePage: { type: Function }
    }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_login_PhoneInput__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_login_OTPInput__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'login',
    components: {
        PhoneInput: __WEBPACK_IMPORTED_MODULE_0__components_login_PhoneInput__["a" /* default */],
        OTPInput: __WEBPACK_IMPORTED_MODULE_1__components_login_OTPInput__["a" /* default */]
    },
    data: function data() {
        return {
            type: null,
            phone: null
        };
    },
    methods: {
        changeType: function changeType(type) {
            this.type = type;
        },
        submitPhone: function submitPhone(phone) {
            this.phone = phone;
        },
        submitOTP: function submitOTP(otp) {
            this.$router.push({ name: 'RegisterPage' });
        }
    }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        submitPhone: { type: Function }
    },
    data: function data() {
        return {
            error: false,
            phone: ''
        };
    }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        submitOTP: { type: Function }
    },
    data: function data() {
        return {
            error: false,
            otp: ''
        };
    }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  data: function data() {
    return {
      form: {
        name: "",
        license: "",
        brand: "",
        color: ""
      }
    };
  },

  methods: {
    handleSubmit: function handleSubmit() {
      console.log(this.form);
    }
  }
}));

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  data: function data() {
    return {
      accepted: false
    };
  },

  methods: {
    handleRegister: function handleRegister() {
      this.$router.push({ name: "HomePage" });
    }
  }
}));

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header__ = __webpack_require__(13);
var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  data: function data() {
    return { isParked: false };
  },

  components: {
    Header: __WEBPACK_IMPORTED_MODULE_1__components_Header__["a" /* default */]
  },
  computed: {
    parkStatus: function parkStatus() {
      return _this.isParked ? "ฝากแล้ว" : "ยังไม่ฝาก";
    }
  },
  methods: {
    handlePark: function handlePark() {
      this.$router.push({ name: "WaitPage" });
    }
  }
}));

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69941328_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(55);
function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69941328"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69941328_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isShowMenu: false
        };
    },
    methods: {
        setShowMenu: function setShowMenu() {
            this.isShowMenu = !this.isShowMenu;
        }
    }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_waiting_MockupMap__ = __webpack_require__(60);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MockupMap: __WEBPACK_IMPORTED_MODULE_0__components_waiting_MockupMap__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$router.push({ name: "ContactPage" });
    }, 10000);
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$router.push({ name: "SelectDriverPage" });
    }, 5000);
  }
}));

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  methods: {
    handlePark: function handlePark() {
      this.$router.push({ name: "WaitingPage" });
    },
    handleHome: function handleHome() {
      this.$router.push({ name: "HomePage" });
    }
  }
}));

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactCard__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  components: { ContactCard: __WEBPACK_IMPORTED_MODULE_1__components_ContactCard__["a" /* default */] },
  methods: {
    toHome: function toHome() {
      this.$router.push({ name: "FinishPage" });
    }
  }
}));

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/0lEQVQ4jaWUwUrEMBCGv7aasgiCsLLBk8d9DvPceQ8vC54kYk9FaFMp9bAJJDFmDfvfMjP5+JPMpNm2jZJ6qe6BHTBZo8dSbVOCOdBzEHorAduiLXi6sP4frJfqARBJWLh4Vtlj9lLtL7h4t0YPWZi7m0fgNuOmpAX4Bj6t0WMjDi8COFYA/tJrW+mkJNFao7+A+UrQDEz+NU9XAGfgZI1eWwBr9OqASyVo8SAI+swFiuOS0ehBEcwna2HhIoXdVcKi+hRW2yZR/U2S7DIbfJfnpiOqT2EDZ+sdsAKDNfrDJ3upDsA+zIebfw16L5VwDqbwpYJ8x/mzXKzRUSv9AJUPYFacWSKBAAAAAElFTkSuQmCC"

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toHome: function toHome() {
      this.$router.push({ name: "HomePage" });
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header__ = __webpack_require__(13);
var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  data: function data() {
    return { isParked: false };
  },

  components: {
    Header: __WEBPACK_IMPORTED_MODULE_1__components_Header__["a" /* default */]
  },
  computed: {
    parkStatus: function parkStatus() {
      return _this.isParked ? "ฝากแล้ว" : "ยังไม่ฝาก";
    }
  },
  methods: {
    handlePark: function handlePark() {
      this.$router.push({ name: "WaitPage" });
    }
  }
}));

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(31);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ae1d58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(30);
function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ae1d58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_landing_LandingPage__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_login_LoginPage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_register_RegisterPage__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_termsConditions_TermsConditionsPage__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_home_HomePage__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_waiting_WaitingPage__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_wait_WaitPage__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_selectDriver_SelectDriverPage__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_contact_ContactPage__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_finish_FinishPage__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_about_AboutPage__ = __webpack_require__(83);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'LandingPage',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_landing_LandingPage__["a" /* default */]
  }, {
    path: '/login',
    name: 'LoginPage',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_login_LoginPage__["a" /* default */]
  }, {
    path: '/register',
    name: 'RegisterPage',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_register_RegisterPage__["a" /* default */]
  }, {
    path: '/terms',
    name: 'TermsConditionsPage',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_termsConditions_TermsConditionsPage__["a" /* default */]
  }, {
    path: '/home',
    name: 'HomePage',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_home_HomePage__["a" /* default */]
  }, {
    path: '/driving',
    name: 'WaitingPage',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_waiting_WaitingPage__["a" /* default */]
  }, {
    path: '/wait',
    name: 'WaitPage',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_wait_WaitPage__["a" /* default */]
  }, {
    path: '/select',
    name: 'SelectDriverPage',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_selectDriver_SelectDriverPage__["a" /* default */]
  }, {
    path: '/contact',
    name: 'ContactPage',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_contact_ContactPage__["a" /* default */]
  }, {
    path: '/finish',
    name: 'FinishPage',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_finish_FinishPage__["a" /* default */]
  }, {
    path: '/about',
    name: 'AboutPage',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_about_AboutPage__["a" /* default */]
  }]
}));

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPage_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41d207f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPage_vue__ = __webpack_require__(35);
function injectStyle (ssrContext) {
  __webpack_require__(34)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41d207f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41d207f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-blue main-bg"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"mh-100 d-flex flex-column justify-content-center"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"align-self-end btn bg-white text-blue btn-link border border-light rounded-circle",attrs:{"to":{name: 'LoginPage'}}},[_vm._v(" > ")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"mb-3",attrs:{"src":__webpack_require__(36)}}),_vm._v(" "),_c('h2',{staticClass:"text-white"},[_vm._v("ตัวกลาง")]),_vm._v(" "),_c('div',{staticClass:"text-white"},[_vm._v("\n                ที่จะเชื่อมต่อผู้ที่พบเจอปัญหา "),_c('br'),_vm._v(" เกี่ยวกับการจอดรถเข้ากับ "),_c('br'),_vm._v(" ผู้ที่ยินดีให้บริการ "),_c('br'),_vm._v(" รับรถไปจอดให้\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056be52e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__ = __webpack_require__(45);
function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-056be52e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_056be52e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneInput_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_628c3630_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneInput_vue__ = __webpack_require__(41);
function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-628c3630"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhoneInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_628c3630_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhoneInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"d-flex flex-column align-items-center",on:{"submit":function (e) {
        e.preventDefault();

        if (!/^[0-9]{9}$/.test(_vm.phone)) {
            _vm.error = true
            return
        }

        var newPhone = '+66' + _vm.phone
        _vm.submitPhone(newPhone)
    }}},[_c('div',{staticClass:"form-row align-items-center"},[_c('div',{staticClass:"col-auto"},[_c('label',{staticClass:"sr-only",attrs:{"for":"phone"}},[_vm._v("เบอร์โทรศัพท์")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticClass:"form-control",attrs:{"type":"text","id":"phone","placeholder":"เบอร์โทรศัพท์"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}})])])]),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"text-danger rounded-pill"},[_vm._v("เบอร์โทรศัพท์ไม่ถูกต้อง")]):_vm._e(),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("+66")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link bg-blue text-white border border-light rounded-circle",attrs:{"type":"submit"}},[_c('i',{staticClass:"fas fa-chevron-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OTPInput_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b2bf484_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OTPInput_vue__ = __webpack_require__(44);
function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b2bf484"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OTPInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b2bf484_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OTPInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"d-flex flex-column align-items-center",on:{"submit":function (e) {
    e.preventDefault()
    if (!/^[0-9]{6}$/.test(_vm.otp)) {
        _vm.error = true
        return
    }
    _vm.submitOTP(_vm.otp)
    }}},[_c('div',{staticClass:"form-row align-items-center"},[_c('div',{staticClass:"col-auto"},[_c('label',{staticClass:"sr-only",attrs:{"for":"phone"}},[_vm._v("OTP")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otp),expression:"otp"}],staticClass:"form-control",attrs:{"type":"text","id":"otp","placeholder":"OTP"},domProps:{"value":(_vm.otp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.otp=$event.target.value}}})])])]),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"text-danger"},[_vm._v("OTP ไม่ถูกต้อง")]):_vm._e(),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("OTP")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link bg-blue text-white border border-light rounded-circle",attrs:{"type":"submit"}},[_c('i',{staticClass:"fas fa-chevron-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-bg"},[_c('div',{staticClass:"container"},[(!_vm.type)?_c('div',{staticClass:"d-flex flex-column align-items-center justify-content-sm-center mh-100"},[_c('h2',{staticClass:"head my-3"},[_vm._v("คุณคือใคร?")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column flex-md-row justify-content-between justify-content-md-center align-items-md-center w-100 py-3"},[_c('button',{staticClass:"blue-btn mr-md-5 py-0 py-md-4 align-self-end align-self-md-center type-btn btn btn-link bg-blue text-white",on:{"click":function () { return _vm.changeType('owner'); }}},[_c('p',{staticClass:"end-txt ml-auto ml-md-0 mb-1 mt-auto mt-md-0"},[_vm._v("เจ้าของรถ")])]),_vm._v(" "),_c('button',{staticClass:"blue-btn mt-4 mt-sm-0 ml-md-5 py-0 py-md-4 align-self-start align-self-md-center type-btn btn btn-link bg-blue text-white",attrs:{"disabled":true},on:{"click":function () { return _vm.changeType('driver'); }}},[_c('p',{staticClass:"start-txt mb-1 mr-auto mr-md-0 mt-auto mt-md-0"},[_vm._v("คนขับ")])])])]):_c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center mh-100"},[(_vm.type === 'owner')?_c('div',{staticClass:"d-flex flex-column align-items-center"},[(!_vm.phone)?_c('PhoneInput',{attrs:{"submitPhone":_vm.submitPhone},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}):_c('OTPInput',{attrs:{"submitOTP":_vm.submitOTP},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1):(_vm.type === 'driver')?_c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('PhoneInput')],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterPage_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0339154c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterPage_vue__ = __webpack_require__(48);
function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0339154c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0339154c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-bg"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center mh-100"},[_c('div',{staticClass:"form col-12"},[_c('label',{attrs:{"for":"name"}},[_vm._v("ชื่อ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],attrs:{"name":"name","id":"name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"mt-3",attrs:{"for":"license-plate"}},[_vm._v("ทะเบียนรถ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.license),expression:"form.license"}],attrs:{"name":"license-plate","id":"license-plate"},domProps:{"value":(_vm.form.license)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "license", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"mt-3"},[_vm._v("ยี่ห้อ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.brand),expression:"form.brand"}],attrs:{"name":"cars"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "brand", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"volvo"}},[_vm._v("Volvo")]),_vm._v(" "),_c('option',{attrs:{"value":"saab"}},[_vm._v("Saab")]),_vm._v(" "),_c('option',{attrs:{"value":"fiat"}},[_vm._v("Fiat")]),_vm._v(" "),_c('option',{attrs:{"value":"audi"}},[_vm._v("Audi")])]),_vm._v(" "),_c('label',{staticClass:"mt-3",attrs:{"for":"color"}},[_vm._v("สีรถ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.color),expression:"form.color"}],attrs:{"name":"color"},domProps:{"value":(_vm.form.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "color", $event.target.value)}}}),_vm._v(" "),_c('router-link',{staticClass:"blue-btn link btn rounded-pill bg-blue text-white mt-5",attrs:{"to":{ name: 'TermsConditionsPage'}},on:{"click":_vm.handleSubmit}},[_vm._v("ข้อตกลงและการใช้งาน")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsConditionsPage_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99cd83a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsConditionsPage_vue__ = __webpack_require__(51);
function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99cd83a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsConditionsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99cd83a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsConditionsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-bg bg-blue"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center mh-100"},[_c('div',{staticClass:"bg-white  text-center py-3 px-3 rounded"},[_c('h3',[_vm._v("ข้อตกลงและการใช้งาน")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.accepted),expression:"accepted"}],attrs:{"type":"checkbox","id":"accept","name":"accept"},domProps:{"checked":Array.isArray(_vm.accepted)?_vm._i(_vm.accepted,null)>-1:(_vm.accepted)},on:{"change":function($event){var $$a=_vm.accepted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.accepted=$$a.concat([$$v]))}else{$$i>-1&&(_vm.accepted=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.accepted=$$c}}}}),_c('label',{staticClass:"ml-2",attrs:{"for":"accept"}},[_vm._v("ยอมรับเงื่อนไขที่ทางบริษัทกำหนด")])]),_vm._v(" "),_c('button',{staticClass:"blue-btn btn rounded-pill bg-blue text-white mt-3",attrs:{"disabled":!_vm.accepted},on:{"click":_vm.handleRegister}},[_vm._v("ลงทะเบียน")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms text-left bg-white my-3 py-3 px-2"},[_c('ol',[_c('li',[_vm._v("โปรดอ่านข้อตกลงการใช้บริการอย่างถี่ถ้วน การใช้บริการ (ตามที่ระบุไว้) ถือว่าคุณได้ยอมรับว่าคุณได้อ่าน และเข้าใจในข้อกำหนดต่างๆ ในข้อตกลงการใช้งานที่กำหนดไว้ใช้กับคุณ ข้อกำหนดต่างๆ นี้ ถือเป็นข้อตกลงที่มีผลผูกพันทางกฎหมาย (“ข้อตกลง”) หากคุณไม่ยินยอมต่อข้อตกลงการใช้บริการ โปรดยกเลิกการใช้งาน หรือหยุดการใช้งานแอปพลิเคชันหรือการบริการ")]),_vm._v(" "),_c('li',[_vm._v("พาร์คคลาวด์คือบริษัททางเทคโนโลยี ที่ให้บริการแพลตฟอร์มสำหรับผู้ใช้งาน เพื่อรับการบริการ ที่ให้บริการโดยผู้ให้บริการบุคคลที่สาม หน้าที่ของเราคือเป็นตัวกลางสื่อสารระหว่างผู้ใช้งานกับผู้ให้บริการบุคคลที่สาม")]),_vm._v(" "),_c('li',[_vm._v("“ข้อมูลส่วนตัว” หมายถึง ข้อมูลที่ใช้ในการยืนยันตัวตนของคุณ หรือที่ยืนยันได้ว่าเป็นคุณ ซึ่งรวมถึงแต่ไม่จำกัดเพียง ชื่อของคุณ, สัญชาติ, เบอร์โทรศัพท์, ข้อมูลธนาคารและบัตรเครดิต, อีเมล, ภาพของคุณ, เลขบัตรประชาชน, เชื้อชาติ, วันเกิด, สถานภาพสมรส, ศาสนา, ข้อมูลสุขภาพ, ข้อมูลยานพาหนะและประกันภัย")]),_vm._v(" "),_c('li',[_vm._v("“แพลตฟอร์ม” หมายถึง แพลตฟอร์มเทคโนโลยีที่เกี่ยวข้องกับพาร์คคลาวด์, หรือเว็บไซต์ที่เมื่อใช้เชื่อมต่อกับแอปพลิเคชัน จะทำให้ผู้ใช้งานสามารถทำเรื่องขอ หรือเข้าถึง คำตอบหรือวิธีการแก้ปัญหาต่าง ๆ")]),_vm._v(" "),_c('li',[_vm._v("“บริการ” หมายถึง การเชื่อมต่อระหว่างผู้ใช้งานกับผู้ให้บริการบุคคลที่สามผ่านทางแอปพลิเคชัน และ/หรือ แพลตฟอร์ม")]),_vm._v(" "),_c('li',[_vm._v("“ผู้ให้บริการบุคคลที่สาม” หมายถึง บุคคลที่สามอิสระ ที่มอบวิธีการแก่ปัญหาแก่ผู้ใช้งานผ่านการบริการ ซึ่งรวมถึงคนขับรถ และพ่อค้าบุคคลที่สาม")]),_vm._v(" "),_c('li',[_vm._v("“ผู้ใช้งาน” หมายถึง ผู้ใดก็ตามที่ใช้งานแอปพลิเคชัน และ/หรือ แพลตฟอร์ม เพื่อค้นหาและบรรลุทางเลือกและ")]),_vm._v(" "),_c('li',[_vm._v("“ค่าบริการผู้ใช้งาน” จึงหมายถึง ค่าบริการที่เกิดขึ้นจากผู้ใช้งาน โดยการใช้งานบริการเพื่อบรรลุทางเลือก ซึ่งรวมถึง ค่าบริการแอปพลิเคชันต่างๆ, ภาษีและค่าบริการ หรือค่าใช้จ่ายที่อาจเกิดขึ้นในการใช้งานเฉพาะกิจ ของบริการหรือทางเลือก")]),_vm._v(" "),_c('li',[_vm._v("\n            ในการใช้บริการ คุณได้แสดง, อนุญาตและรับข้อผูกมัดว่า:\n            "),_c('ol',[_c('li',[_vm._v("คุณมีอายุไม่ต่ำกว่ายี่สิบ (20) ปี หรือได้รับอนุญาตตามกฎหมายเพื่อเข้าร่วมข้อตกลง")]),_vm._v(" "),_c('li',[_vm._v("ข้อมูลทั้งหมดที่คุณมอบให้ เป็นข้อมูลตาจริงและถูกต้อง")]),_vm._v(" "),_c('li',[_vm._v("คุณจะใช้ แอปพลิเคชัน, แพลตฟอร์ม, บริการและทางเลือกตามหน้าที่ที่ได้กำหนดไว้และอยู่ภายใต้กฎหมาย")]),_vm._v(" "),_c('li',[_vm._v("คุณจะต้องเก็บรหัสผ่านบัญชีหรือข้อมูลยืนยันตัวซึ่งสามารถใช้เข้าถึงการบริการที่เรามอบให้ อย่างปลอดภัยและเป็นความลับ")]),_vm._v(" "),_c('li',[_vm._v("คุณตกลงที่จะแจ้งให้เราทราบทันทีเมื่อมีการใช้บัญชีของคุณโดยไม่ได้รับอนุญาตหรือ มีการละเมิดความปลอดภัยเกิดขึ้น")]),_vm._v(" "),_c('li',[_vm._v("คุณจะต้องไม่หาประโยชน์ทางการค้าจากแอปพลิเคชันโดยไม่ได้รับอนุญาต รวมถึงโดยไม่จำกัดถึง การปรับเปลี่ยนเนื้อหาใดๆ ของแอปพลิชั่น หรือคัดลอก, ทำใหม่, แสดงในที่สาธารณะ, จำหน่ายหรือใช้เพื่อการติดต่อทางธุรกิจและสาธารณะโดยไม่ได้รับอนุญาต")]),_vm._v(" "),_c('li',[_vm._v("คุณจะต้องไม่ให้ผู้อื่นใช้ข้อมูลส่วนตัวหรือสถานะผู้ใช้งานของคุณ และคุณไม่สามารถกำหนดหรือส่งต่อบัญชีผู้ใช้งานของคุณแก่ผู้ใดหรือสิ่งใดก็ตาม")]),_vm._v(" "),_c('li',[_vm._v("คุณจะต้องมอบหลักฐานยืนยันตน หรือเอกสารอื่นๆ, ใบอนุญาต, ใบอนุมัติ ซึ่งทางเราจะร้องขออย่างสมเหตุสมผล")]),_vm._v(" "),_c('li',[_vm._v("คุณจะต้องไม่ใช้แอปพลิเคชันในการเก็บหรือส่งสิ่งใดก็ตามที่ผิดกฎหมาย หรือ ใช้ในเชิงหลอกลวง")]),_vm._v(" "),_c('li',[_vm._v("คุณจะต้องไม่ใช้แอปพลิเคชันและ/หรือซอฟต์แวร์เพื่อก่อให้เกิดความรำคาญ หรือประพฤติไม่เหมาะสม หรือ ประพฤติอย่างไม่เคารพต่อแกร็บหรือ ผู้ให้บริการบุคคลที่สาม")]),_vm._v(" "),_c('li',[_vm._v("คุณจะต้องมอบข้อมูลที่เที่ยงตรง, เป็นปัจจุบันและสมบูรณ์ตามที่ร้องขอเพื่อการบริการและมีภาระผูกพันกับความรับผิดชอบต่อการดูแลและอัพเดทข้อมูลอย่างต่อเนื่องเพื่อให้มีความเที่ยงตรง, เป็นปัจจุบันและสมบูรณ์อยู่ตลอดเวลาระหว่างข้อกำหนดภายในข้อตกลง คุณยินยอมว่าแกร็บจะต้องพึ่งข้อมูลที่มีความเที่ยงตรง, เป็นปัจจุบันและสมบูรณ์ของคุณ คุณเข้าใจว่าหากข้อมูลของคุณนั้นไม่เป็นความจริง, ไม่มีความเที่ยงตรง, ไม่เป็นปัจจุบันและไม่สมบูรณ์ไม่ว่าในทางใดก็ตามแกร็บถือสิทธิแต่ไม่เป็นพันธะ ที่จะระงับข้อตกลงและระงับการใช้บริการของคุณโดยไม่ต้องแจ้งให้ทราบล่วงหน้า")]),_vm._v(" "),_c('li',[_vm._v("คุณยินยอมที่จะรับผิดชอบต่อความเสียหายหรือสูญหายที่เกิดจากตัวคุณเอง หรือจากฝ่ายอื่นๆที่มีผลมาจากการละเมิดข้อตกลงของคุณ")])])]),_vm._v(" "),_c('li',[_vm._v("ความเข้ากันได้ โดยรูปแบบและเวอร์ชั่นของเราท์เตอร์ที่แตกต่างกัน, เบราว์เซอร์และอุปกรณ์อาจมีเฟิร์มแวร์ที่อาจจะไม่สามารถเข้ากันได้กับแอปพลิเคชัน, แพลตฟอร์มและ/หรือซอฟต์แวร์ ในระหว่างที่เราดำเนินการพัฒนาแอปพลิเคชัน, แพลตฟอร์มและ/หรือซอฟต์แวร์อย่างต่อเนื่อง เพื่อที่จะรองรับการใช้งานโดยอุปกรณ์และรูปแบบที่ใช้กันโดยทั่วไปในตลาดและเบราว์เซอร์ทั้งหมดที่มักจะถูกใช้เพื่อเข้าถึงที่แอปพลิเคชัน, แพลตฟอร์มและ/หรือซอฟต์แวร์ ให้มากที่สุดเท่าที่จะมากได้, เราไม่สามารถรับประกันถึงความเข้ากันได้ของแอปพลิเคชัน, แพลตฟอร์มและ/หรือซอฟต์แวร์ ต่ออุปกรณ์มือถือรุ่นหนึ่งรุ่นใด หรือฮาร์ดแวร์ใดได้")]),_vm._v(" "),_c('li',[_vm._v("\n            การชำระเงิน\n            "),_c('ol',[_c('li',[_vm._v("เมื่อคุณได้บรรลุการใช้บริการ คุณจะถูกร้องขอให้ชำระเงินจำนวนเต็มแต่ผู้บริการบุคคลที่สาม โดยเลือกหนึ่งในวิธีการชำระเงินที่สามารถใช้ได้ผ่านแอปพลิเคชัน การชำระเงินใดๆที่ตามมาในการเลือกนั้นจะไม่สามารถคืนเงินได้โดยอัตโนมัติ")]),_vm._v(" "),_c('li',[_vm._v("คุณอาจเลือกที่จะจ่ายผู้ให้บริการบุคคลที่สามสำหรับค่าใช้จ่ายในการแก้ปัญหาโดยเงินสดหรือวิธีใดๆก็ตามที่ทำได้, โดยบัตรเครดิตหรือบัตรเดบิต(“บัตร”) ที่ทำได้")]),_vm._v(" "),_c('li',[_vm._v("หากคุณเลือกที่จะจ่ายโดยบัตรคุณจะต้องลงทะเบียนบัตรที่สามารถใช้ได้ของคุณตามข้อมูลที่ระบุไว้ในแอปพลิเคชัน")]),_vm._v(" "),_c('li',[_vm._v("คุณยินยอมที่จะตรวจสอบและมอบข้อมูลของบัตรเมื่อลงทะเบียนบัตรกับเรา และเมื่อคุณใช้บริการ")]),_vm._v(" "),_c('li',[_vm._v("คุณยินยอมที่จะให้ความร่วมมือในเหตุที่มีความสัมพันธ์กับการป้องกันอาชญากรรมทางการเงิน ซึ่งจะมีการร้องขอให้ช่วยเหลือและสนับสนุนแกร็บตามกฎหมายและข้อกำหนดที่มีอยู่")])])]),_vm._v(" "),_c('li',[_vm._v("\n            การยกเลิก\n            "),_c('ol',[_c('li',[_vm._v("คุณอาจยกเลิกคำร้องขอบริการขนส่งโดยยานพาหนะได้ทุกเวลาก่อนที่คุณจะขึ้นยานพาหนะของผู้ให้บริการบุคคลที่สาม ที่ได้รับการจับคู่กับคุณผ่านการบริการ")]),_vm._v(" "),_c('li',[_vm._v("หากคุณตัดสินใจที่จะยกเลิกการจองของคุณ หรือไม่ได้ไปยังสถานที่ที่นัดไว้กับคนขับ คุณจะถูกเก็บค่าบริการยกเลิกหรือ ค่าบริการยกเลิกอื่นๆที่พาร์คคลาวด์อาจระบุไว้เป็นครั้งคราวผ่าน นโยบายการยกเลิก")])])]),_vm._v(" "),_c('li',[_vm._v("\n            การประเมิน\n            "),_c('ol',[_c('li',[_vm._v("ผู้ใช้งานและผู้ให้บริการบุคคลที่สามอาจจะได้รับการอนุญาตให้ประเมินกันและกันในส่วนของการให้บริการ การแก้ไขปัญหา")]),_vm._v(" "),_c('li',[_vm._v("ทุกๆการประเมินจะถูกบันทึกลงในระบบของแกร็บโดยอัตโนมัติ และแกร็บจะวิเคราะห์การประเมินที่ได้รับทั้งหมด แกร็บอาจจะกระทำการตามเห็นสมควรซึ่งรวมถึงการ ระงับการใช้บริการของคุณโดยไม่บอกล่วงหน้า หรือชดใช้ค่าใช้จ่ายใดๆแก่คุณ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5437d722_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__ = __webpack_require__(56);
function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5437d722"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5437d722_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"desktop-header d-none d-sm-flex justify-content-between align-items-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{name: 'HomePage'}}},[_c('img',{staticClass:"h-100",attrs:{"src":__webpack_require__(3)}})])],1),_vm._v(" "),_c('ul',{staticClass:"desktop-header justify-content-center list-unstyled m-0"},[_c('router-link',{staticClass:"btn btn-link text-black",attrs:{"to":{name: 'AboutPage'}}},[_vm._v("เกี่ยวกับเรา")]),_vm._v(" "),_c('a',{staticClass:"btn btn-link text-black",attrs:{"href":"https://www.facebook.com/parcloud/"}},[_vm._v("Facebook Link")])],1)]),_vm._v(" "),_c('div',{staticClass:"mobile-header py-1 d-flex d-sm-none justify-content-between align-items-center"},[_c('div',{staticClass:"img-container"},[_c('router-link',{attrs:{"to":{name: 'HomePage'}}},[_c('img',{staticClass:"h-100",attrs:{"src":__webpack_require__(3)}})])],1),_vm._v(" "),_c('button',{staticClass:"hamburger-div",on:{"click":function () { return _vm.setShowMenu(); }}},[_c('div',{class:{ show: _vm.isShowMenu },attrs:{"id":"hamburger"}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])])])]),_vm._v(" "),_c('ul',{staticClass:"mobile-item d-flex flex-column list-unstyled m-0 d-sm-none",class:{ show: _vm.isShowMenu }},[_c('router-link',{staticClass:"btn btn-link text-black",attrs:{"to":{name: 'AboutPage'}}},[_vm._v("เกี่ยวกับเรา")]),_vm._v(" "),_c('a',{staticClass:"btn btn-link",attrs:{"href":"https://www.facebook.com/parcloud/"}},[_vm._v("Facebook Link")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_c('div',{staticClass:"container mt-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column flex-md-row justify-content-between justify-content-md-center align-items-md-center w-100 py-3"},[_c('button',{staticClass:"mr-md-5 py-4 align-self-end align-self-md-center type-btn btn btn-link bg-blue text-white d-flex flex-column align-items-center",attrs:{"disabled":_vm.isParked},on:{"click":_vm.handlePark}},[_c('p',{staticClass:"mb-0"},[_vm._v("หาคนจอดรถให้")])]),_vm._v(" "),_c('button',{staticClass:"mt-4 mt-sm-0 ml-md-5 py-4 align-self-start align-self-md-center type-btn btn btn-link bg-grey text-white d-flex flex-column align-items-center",attrs:{"disabled":!_vm.isParked},on:{"click":_vm.handlePark}},[_c('p',{staticClass:"mb-0"},[_vm._v("หาคนขับรถให้")])])]),_vm._v(" "),_c('a',{staticClass:"btn btn-link mt-5",attrs:{"href":"https://www.facebook.com/parcloud/"}},[_vm._v("Facebook Link")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"img-container w-25 flex-grow-1 rounded overflow-hidden"},[_c('img',{staticClass:"w-100",attrs:{"src":"https://via.placeholder.com/150"}})]),_vm._v(" "),_c('div',{staticClass:"ml-3"},[_c('h4',[_vm._v("สมชาย")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('div',[_c('p',{staticClass:"mb-0"},[_vm._v("สถานะ")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("กำลังใช้งาน")])]),_vm._v(" "),_c('div',{staticClass:"car w-25 flex-grow-1 ml-2"},[_c('img',{staticClass:"w-100",attrs:{"src":__webpack_require__(57)}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/real-car.da31502.png";

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaitingPage_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88b06878_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaitingPage_vue__ = __webpack_require__(64);
function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88b06878"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaitingPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88b06878_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaitingPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MockupMap_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb7f18fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MockupMap_vue__ = __webpack_require__(62);
function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb7f18fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MockupMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb7f18fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MockupMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"circle-driver position-absolute"}),_vm._v(" "),_c('div',{staticClass:"circle-car position-absolute"}),_vm._v(" "),_c('img',{staticClass:"w-100",attrs:{"src":__webpack_require__(63)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mockup_map.728ba04.jpg";

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"map overflow-hidden"},[_c('MockupMap')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaitPage_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb27f7c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaitPage_vue__ = __webpack_require__(67);
function injectStyle (ssrContext) {
  __webpack_require__(66)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb27f7c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaitPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb27f7c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaitPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 w-70 text-center"},[_c('img',{attrs:{"src":"https://via.placeholder.com/150"}}),_vm._v(" "),_c('h4',{staticClass:"mt-4"},[_vm._v("กำลังหาคนขับ...")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectDriverPage_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb6943c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectDriverPage_vue__ = __webpack_require__(70);
function injectStyle (ssrContext) {
  __webpack_require__(69)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bb6943c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectDriverPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb6943c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectDriverPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"container pt-5"},[_c('img',{attrs:{"src":__webpack_require__(71)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(72)},on:{"click":_vm.handlePark}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/select.cd867da.png";

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactPage_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eccc4926_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactPage_vue__ = __webpack_require__(78);
function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eccc4926"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eccc4926_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11fa57c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactCard_vue__ = __webpack_require__(77);
function injectStyle (ssrContext) {
  __webpack_require__(76)
}
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11fa57c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11fa57c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box mt-5"},[_c('img',{attrs:{"src":"https://via.placeholder.com/150"}}),_vm._v(" "),_c('div',{staticClass:"ml-4"},[_c('h4',[_c('b',[_vm._v("อนันท์ ศรีแก้ว")])]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__(4)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(4)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(4)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(20)}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(20)}})]),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("กำลังขับรถไปที่")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("บ้านลำดวนอพาร์ทเมนท์")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-5"},[_c('contact-card')],1),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(79)}})]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('button',{staticClass:"blue-btn btn rounded-pill bg-blue text-white mt-3",on:{"click":_vm.toHome}},[_vm._v("เสร็จสิ้น")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contact-box.053206c.png";

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishPage_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91e8138c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishPage_vue__ = __webpack_require__(82);
function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-91e8138c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91e8138c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('h4',[_vm._v("รถของคุณได้ทำการเข้าจอดเรียบร้อย")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"blue-btn btn rounded-pill bg-blue text-white mt-3",on:{"click":_vm.toHome}},[_vm._v("กลับสู่หน้าหลัก")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cost-container border rounded p-4 border-blue"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("ยอดเงินปัจจุบัน")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("100 บาท")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("ค่าใช้จ่าย")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("70 บาท")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("ยอดเงินคงเหลือ")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("30 บาท")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d32bc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__ = __webpack_require__(85);
function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19d32bc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d32bc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-3"},[_c('div',{staticClass:"img-container mb-3"},[_c('img',{staticClass:"w-100",attrs:{"src":__webpack_require__(3)}})]),_vm._v(" "),_c('p',[_vm._v("\n        Why ParCloud\n        "),_c('br'),_vm._v("\nทุกวันนี้ นอกจากการที่เราจะต้องฝ่าฟันรถติดบนท้องถนน เรายังต้องทุกข์ทนกับการหาที่จอดรถตามสถานที่ต่างๆที่เราไป ไม่ว่าจะเป็นห้างสรรพสินค้าหรือร้านอาหาร บางครั้งเราใช้เวลามากกว่าครึ่งชั่วโมงในการวนหาที่จอดรถ ซึ่งทุกคนคงเคยประสบพบเจอกับปัญหานี้กันมาบ้าง เราจึงเริ่มคิดถึงความเป็นไปได้ที่เราจะหลีกเลี่ยงการจอดรถเอง ทั้งหมดนี้คือจุดเริ่มต้นของParCloud\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n        บางคนอาจจะสงสัยว่า ParCloud คืออะไร ParCloud มาจากคำว่า Parking+Cloud ซึ่งคำว่า cloud ในที่นี้ มีแรงบันดาลใจมาจาก Cloud Storage Server ที่เน้นถึงพื้นที่ในการเก็บข้อมูล และยังเป็นระบบที่พร้อมใช้งานได้ตลอดเวลา นอกจากนี้ยังมีระบบป้องกันข้อมูลเสียหายต่างๆ\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n        What impacts we have created to social\n        "),_c('br'),_vm._v("\nเนื่องจากบุคคลที่สาม(ผู้รับรถไปจอด) จะได้รับรายได้จากการมาเป็นผู้ให้บริการรับรถหรือนำรถกลับมาให้เจ้าของรถ ซึ่งเราสามารถช่วยสร้างโอกาส สร้างอาชีพ และสร้างความมั่นคงด้านการเงินให้กับผู้คนนับพันในประเทศของเรา\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[23]);


// WEBPACK FOOTER //
// static/js/app.94c67b4757544e4fd7e4.js